import { LabProvider } from "../../context/labContext";
import { Outlet } from "react-router-dom";
import { BtnMenu, Menu } from "./_menu";
import { motion } from "framer-motion";
import { Next, BtnPrev, Before } from "./Next";
import Footer from "../admin/Footer";

const _Lab = ({ open, setOpen }) => {

    return (
        <>
            <BtnMenu open={open} setOpen={setOpen} />
            {open && <Menu open={open} setOpen={setOpen} />}

            <motion.div
                style={{ overflowY: "scroll" }}
                initial={{ x: '200%' }}
                animate={{ x: 0 }}
                exit={{ y: '-100%' }}
                transition={{ duration: 0.5 }}
                className="w-100 h-100 d-flex flex-column p-md-5 mx-md-5 ">
                <div className="container d-flex flex-column mt-4 pt-5 pt-md-0 h-100 align-items-center">
                    <div className="col-md-9 col-12">
                        <LabProvider>
                            <Outlet />
                        </LabProvider>
                    </div>
                    <Footer />
                </div>

            </motion.div>
            <Next name="Contact" link="/contact" />
            <Before name="Portafolio" link="/portafolio" />

        </>
    )

}
export default _Lab;